import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { BaseLayoutFactory } from '../../../../components/base-layout-factory';
import { AmendmentDetailProvider } from './context/amendment-detail-context';
import { AmendmentDetailComponent } from './amendment-detail-component';

export function AmendmentDetailFactory() {
    return (
        <BaseLayoutFactory>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <AmendmentDetailProvider>
                    <AmendmentDetailComponent />
                </AmendmentDetailProvider>
            </LocalizationProvider>
        </BaseLayoutFactory>
    );
}
